import MicroModal from 'micromodal';
import SmoothScroll from "smooth-scroll";
import { domReady } from './_dom_utils';
import { MICRO_MODAL_CONFIG } from './_constants';



function setupGlitch() {
  const targetElementList = document.querySelectorAll<HTMLElement>(".c-glitch__target");

  for (const targetElement of targetElementList) {
    const elementList = [];
    for (let i = 0; i < 5; i += 1) {
      const duplicatedElement = targetElement.cloneNode(true) as HTMLElement;
      duplicatedElement.classList.add("c-glitch__target--duplicated");
      if (!targetElement.parentNode) {
        throw new Error("targetElement.parentNode is null");
      }
      targetElement.parentNode.appendChild(duplicatedElement);
      elementList.push(duplicatedElement);
    }
    targetElement.classList.add("c-glitch__target--original");
    for (const [i, element] of elementList.entries()) {
      element.classList.add(`c-glitch__target--${i + 1}`);
    }


  }

}

// expose MicroModal
// eslint-disable-next-line @typescript-eslint/no-explicit-any
// (window as any).MicroModal = MicroModal

domReady(() => {
  MicroModal.init(MICRO_MODAL_CONFIG);
  setupGlitch();
  (window as any).smoothScroll = new SmoothScroll("[data-smooth-scroll]", {
    speed: 500,
    speedAsDuration: true,
    offset: 60,
    updateURL: false,
  });
});
